var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('location-switcher',{attrs:{"items":_vm.activeLocations,"locationId":_vm.locationId,"isDisabled":_vm.isDisabled}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }